import Account from './Account.svelte';
import Admin from './Admin.svelte';
import AdminLogs from './AdminLogs.svelte';

export default {
	'/Admin/Settings': Account,
	'/Admin/Settings/Account': Account,
	'/Admin/Settings/Admin': Admin,
	'/Admin/Settings/Admin/Logs': AdminLogs
};
